import Image from "next/image";
import IconButton from "@mui/material/IconButton";
import styles from "./CarouselImage.module.scss";

interface CarouselImageButtonsProps {
  prevClassName: string;
  nextClassName: string;
  beginOrEnd: "begin" | "end" | undefined;
  classes?: {
    wrapper?: string;
    prevClassName?: string;
    nextClassName?: string;
  };
}

function CarouselImageButtons({ classes, prevClassName, nextClassName }: CarouselImageButtonsProps) {
  return (
    <>
      <IconButton
        className={classes?.prevClassName}
        id={prevClassName}
        aria-label="Back Button"
      >
        <Image
          src="/image/icon_arrow_down_thick.svg"
          width={40}
          height={40}
          alt="Previous Card"
          className={styles.prev}
        />
      </IconButton>
      <IconButton
        className={classes?.nextClassName}
        id={nextClassName}
        aria-label="Forward Button"
      >
        <Image
          src="/image/icon_arrow_down_thick.svg"
          width={40}
          height={40}
          alt="Previous Card"
          className={styles.next}
        />
      </IconButton>
    </>
  );
}

export default CarouselImageButtons;
